enum ArtistSettingsRotes {
  Account = '/',
  ArtistProfile = '/profile',
  ConfigureMenu = '/configureMenu',
}

export default ArtistSettingsRotes;
